export const Twitter = () => (
  <svg viewBox="0 0 50 50">
    <path
      fill="currentColor"
      d="M38.2 19.3c-.9.4-1.8.6-2.8.7 1-.6 1.8-1.5 2.1-2.6-.9.5-2 .9-3.1 1.1-.9-.9-2.1-1.5-3.5-1.5-2.7 0-4.9 2.1-4.9 4.7 0 .4 0 .7.1 1.1-4-.2-7.6-2-10-4.9-.4.7-.7 1.5-.7 2.3 0 1.6.9 3 2.2 3.9-.8 0-1.5-.2-2.2-.6v.1c0 2.3 1.7 4.1 3.9 4.6-.4.1-.8.2-1.3.2-.3 0-.6 0-.9-.1.6 1.8 2.4 3.2 4.5 3.2-1.7 1.2-3.8 2-6 2-.4 0-.8 0-1.2-.1 2.2 1.3 4.7 2.1 7.4 2.1 8.9 0 13.8-7.1 13.8-13.2v-.6c1.1-.7 1.9-1.5 2.6-2.4z"
    />
  </svg>
)
